import { render, staticRenderFns } from "./MembraneLabelLabelDialog.vue?vue&type=template&id=61682601&scoped=true"
import script from "./MembraneLabelLabelDialog.vue?vue&type=script&lang=js"
export * from "./MembraneLabelLabelDialog.vue?vue&type=script&lang=js"
import style0 from "./MembraneLabelLabelDialog.vue?vue&type=style&index=0&id=61682601&prod&scoped=true&lang=css"
import style1 from "./MembraneLabelLabelDialog.vue?vue&type=style&index=1&id=61682601&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61682601",
  null
  
)

export default component.exports